var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.follow)?_c('v-icon',{staticClass:"justify-start",attrs:{"size":"20","color":"#ffc107"}},[_vm._v("mdi-star")]):_c('v-icon',{staticClass:"pl-5"})
}
var staticRenderFns = []

export { render, staticRenderFns }